import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import attendeeNetworkHealth from '@shoflo/studio-redux/reducers/attendee/attendeeNetworkHealth';
import attendeeReceivedFrame from '@shoflo/studio-redux/reducers/attendee/attendeeReceivedFrame';
import attendeeVoiceIntensity from '@shoflo/studio-redux/reducers/attendee/attendeeVoiceIntensity';
import attendeePresence from '@shoflo/studio-redux/reducers/attendee/attendeePresence';
import attendeeCameraStatus from '@shoflo/studio-redux/reducers/attendee/attendeeCameraStatus';
import userBackground from '@shoflo/studio-redux/reducers/backgroundFilters/userBackground';
import banners from '@shoflo/studio-redux/reducers/banners/banners';
import brandingSettings from '@shoflo/studio-redux/reducers/branding/brandingSettings';
import videoDeviceLost from '@shoflo/studio-redux/reducers/meeting/videoDeviceLost';
import audioInputDevice from '@shoflo/studio-redux/reducers/meeting/audioInputDevice';
import audioOutputDevice from '@shoflo/studio-redux/reducers/meeting/audioOutputDevice';
import transformedVideoInputs from '@shoflo/studio-redux/reducers/meeting/transformedVideoInputs';
import videoInputDevice from '@shoflo/studio-redux/reducers/meeting/videoInputDevice';
import sceneLayout from '@shoflo/studio-redux/reducers/program/sceneLayout';
import sceneLayers from '@shoflo/studio-redux/reducers/program/sceneLayers';
import program from '@shoflo/studio-redux/reducers/program/program';
import readinessCheck from '@shoflo/studio-redux/reducers/readinessCheck/readinessCheck';
import showReadinessCheck from '@shoflo/studio-redux/reducers/readinessCheck/showReadinessCheck';
import sandboxMeetingStatus from '@shoflo/studio-redux/reducers/readinessCheck/sandboxMeetingStatus';
import sandboxMeetingSession from '@shoflo/studio-redux/reducers/readinessCheck/sandboxMeetingSession';
import sessionState from '@shoflo/studio-redux/reducers/sessionState/sessionState';
import sourceUpdateStatus from '@shoflo/studio-redux/reducers/source/sourceUpdateStatus';
import broadcastSources from '@shoflo/studio-redux/reducers/source/sources';
import liveSources from '@shoflo/studio-redux/reducers/source/liveSources';
import user from '@shoflo/studio-redux/reducers/user/user/user';

//User reducers
import features from './features';
import isLoggedOut from './isLoggedOut';
import screenShareRequest from './screenShareRequest';

//Event reducers
import event from '@shoflo/studio-redux/reducers/event/event';
import eventCrew from './eventCrew';

//Team reducers
import team from '@shoflo/studio-redux/reducers/team/team';

//Modal reducer
import modal from './modal';

import meeting from './meeting';
import attendeeRoster from './attendeeRoster';
import broadcast from './broadcast';
import knock from './knock';
import isAudioMuted from './isAudioMuted';
import isVideoActive from './isVideoActive';
import isScreenShareActive from './isScreenShareActive';
import mediaPlayerSettings from './mediaPlayerSettings';
import directorControls from './directorControls';
import directorRequest from './directorRequest';
import directorRequestMessages from './directorRequestMessages';
import isPresenterDismissed from './isPresenterDismissed';
import serverTimeDelta from './serverTimeDelta';
import startProgram from './startProgram';
import presenterId from './presenterId/presenterId';
import validateBroadcast from './validateBroadcast';
import notification from './notification';
import realtimeSocketConnected from './realtimeSocketConnected';
import knockFailed from './knockFailed';
import streamStatus from './stream/streamStatus';

const rootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    modal,
    features,
    user,
    event,
    eventCrew,
    team,
    isLoggedOut,
    meeting,
    attendeeRoster,
    knock,
    audioInputDevice,
    audioOutputDevice,
    videoInputDevice,
    broadcastSources,
    program,
    isAudioMuted,
    isVideoActive,
    isScreenShareActive,
    mediaPlayerSettings,
    broadcast,
    brandingSettings,
    attendeeCameraStatus,
    directorControls,
    directorRequest,
    directorRequestMessages,
    isPresenterDismissed,
    attendeePresence,
    serverTimeDelta,
    startProgram,
    attendeeNetworkHealth,
    attendeeReceivedFrame,
    sandboxMeetingSession,
    readinessCheck,
    streamStatus,
    presenterId,
    sandboxMeetingStatus,
    validateBroadcast,
    notification,
    realtimeSocketConnected,
    knockFailed,
    sessionState,
    showReadinessCheck,
    sourceUpdateStatus,
    videoDeviceLost,
    userBackground,
    transformedVideoInputs,
    attendeeVoiceIntensity,
    liveSources,
    screenShareRequest,
    sceneLayout,
    sceneLayers,
    banners
  });

export default rootReducer;
